import { NavLink } from 'react-router'

const faqs = [
  {
    question: 'How is this different from FreeToastHost?',
    answer:
      'FreeToastHost was built for the desktop era, when members signed up from a computer at home. That world is gone - people run their clubs from a phone now. Speech Agenda is phone-first: sign up for a role, check the live agenda, or manage the club from any screen in a few taps',
  },
  {
    question: 'Can members see the schedule without an account?',
    answer:
      'Yes. Every club has a public, always-live schedule page you can share with a single link. Members and guests can check the upcoming agenda from any device - signing in is only needed to take a role or manage the club',
  },
  {
    question: 'Do members pick their own speeches and roles?',
    answer:
      'Yes. Members sign up for open speech slots and meeting roles themselves, and can swap when plans change. Officers can still assign anything manually - or let auto-assign fill whatever is left, fairly',
  },
  {
    question: 'What happens when someone drops out at the last minute?',
    answer:
      'They hand their role to another member themselves, and the live agenda updates instantly for everyone. No group-chat scramble, no re-sent PDFs - whoever opens the schedule sees the current plan',
  },
  {
    question: 'Will it spam my members with notifications?',
    answer:
      'No. Members get one configurable digest per meeting, plus a single email only when a cancellation leaves a role open or an admin auto-assigns. We deliberately don’t ping for every open role. Quiet notifications are the ones that get read',
  },
  {
    question: 'Can I control who edits what - and who can see members’ contact details?',
    answer:
      'Yes. Unlike a shared spreadsheet, access isn’t all-or-nothing. People act on their own roles without being able to rewrite the rest of the schedule, and member contact details aren’t sitting in a file anyone with the link can copy and walk away with',
  },
  {
    question: 'Does it work well on a phone?',
    answer:
      'It is built for the phone first. The whole web app - signing up for roles, checking the agenda, managing the club - is fully responsive, unlike the desktop-only tables most club tools are made of',
  },
  {
    question: 'Do I have to install anything?',
    answer:
      'No - Speech Agenda is 100% web-based and works in any browser, on any device. There is nothing to install and nothing to update',
  },
  {
    question: 'How do we move from FreeToastHost or Easy-Speak?',
    answer:
      'Start your club, then invite members by email or import your existing roster. Your meetings, roles, and members are up and running the same day - and we are happy to help with the move',
  },
  {
    question: 'How much does it cost?',
    answer: (
      <>
        Speech Agenda is free to start - no credit card required. See the{' '}
        <NavLink to="/pricing" className="text-indigo-400 hover:text-indigo-300">
          pricing page
        </NavLink>{' '}
        for more details
      </>
    ),
  },
]

export default function LandingFAQ() {
  return (
    <div className="bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-4xl divide-y divide-white/10">
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-white">
            Frequently asked questions
          </h2>
          <dl className="mt-10 space-y-6 divide-y divide-white/10">
            {faqs.map((faq) => (
              <div key={faq.question} className="pt-6">
                <dt className="text-base font-semibold leading-7 text-white">
                  {faq.question}
                </dt>
                <dd className="mt-2 pr-12">
                  <p className="text-base leading-7 text-gray-300">
                    {faq.answer}
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
